/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, session: NonNullable<unknown> }} Swap_Replaced_ToastInputs */

const en_us2_swap_replaced_toast = /** @type {(inputs: Swap_Replaced_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} is now in ${i?.session}`)
};

const pt_br2_swap_replaced_toast = /** @type {(inputs: Swap_Replaced_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} entrou no ${i?.session}`)
};

const es_419_swap_replaced_toast = /** @type {(inputs: Swap_Replaced_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} ahora está en ${i?.session}`)
};

const pt_pt2_swap_replaced_toast = /** @type {(inputs: Swap_Replaced_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} entrou no ${i?.session}`)
};

const fr_fr2_swap_replaced_toast = /** @type {(inputs: Swap_Replaced_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} est maintenant dans ${i?.session}`)
};

const de_de2_swap_replaced_toast = /** @type {(inputs: Swap_Replaced_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} ist jetzt in ${i?.session}`)
};

const it_it2_swap_replaced_toast = /** @type {(inputs: Swap_Replaced_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} ora è in ${i?.session}`)
};

/**
* | output |
* | --- |
* | "{name} is now in {session}" |
*
* @param {Swap_Replaced_ToastInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const swap_replaced_toast = /** @type {((inputs: Swap_Replaced_ToastInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Swap_Replaced_ToastInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_swap_replaced_toast(inputs)
	if (locale === "es-419") return es_419_swap_replaced_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_swap_replaced_toast(inputs)
	if (locale === "fr-FR") return fr_fr2_swap_replaced_toast(inputs)
	if (locale === "de-DE") return de_de2_swap_replaced_toast(inputs)
	if (locale === "it-IT") return it_it2_swap_replaced_toast(inputs)
	return en_us2_swap_replaced_toast(inputs)
});
export { swap_replaced_toast as "swap.replaced_toast" }